<div *transloco="let translate" fxFlex fxLayout="column" fxLayoutAlign="space-between stretch">
  <div fxFlex="100" fxLayout="column" class="p-20">
    <form [formGroup]="form" class="form" fxFlex="100" fxLayout="column" fxLayoutGap="8px">
      <div [innerHTML]="translate(TRANSLOCO_PREFIX + '.description')"></div>
      <div [innerHTML]="translate(TRANSLOCO_PREFIX + '.step1')"></div>
      <div [innerHTML]="translate(TRANSLOCO_PREFIX + '.step2')"></div>
      <div fxFlex fxLayoutAlign="center center" class="mb-8">
        <qrcode [qrdata]="qrCodeString" elementType="svg" [width]="200"></qrcode>
      </div>
      <div [innerHTML]="translate(TRANSLOCO_PREFIX + '.step3')"></div>

      <div fxFlex fxLayoutAlign="center center" class="mb-8">
        <p-input-otp [length]="6" formControlName="otpCode"></p-input-otp>
      </div>

      @if (errorMessage) {
        <eg-alert class="mb-8" fxFlex="100" type="error" [message]="errorMessage"></eg-alert>
      }
      @if (infoMsg) {
        <eg-alert type="info" class="mb-8" fxFlex="100" [message]="translate(infoMsg)"> </eg-alert>
      }
    </form>
  </div>

  <div fxLayoutAlign="end center" fxLayout="row wrap" fxLayoutGap="5px" class="eg-modal-footer">
    <button egButton egType="round" egStyle="secondary" (click)="close()">
      {{ translate('action.cancel') }}
    </button>
    <button egButton egType="round" (click)="onVerifyTOTP()">
      {{ translate('action.save') }}
    </button>
  </div>
</div>
